import React from "react";

function CourseForm (){
    return (
         <div className="bg-white text-dark p-4 shadow-lg formbox pt-4 pb-4">
            <h4 className="mb-3">Boost Your JEE/NEET Preparation</h4>
            <form>
                <div className="mb-3">
                    <input type="text" className="form-control" placeholder="Enter Name" />
                </div>
                <div className="mb-3">
                    <input type="text" className="form-control" placeholder="Enter Mobile Number" />
                </div>
                <div className="mb-3">
                    <input type="email" className="form-control" placeholder="Enter Email Id" />
                </div>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <select className="form-select">
                            <option>Select Course</option>
                            <option>JEE</option>
                            <option>NEET</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <select className="form-select">
                            <option>Select Mode</option>
                            <option>Online</option>
                            <option>Offline</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <select className="form-select">
                            <option>Select Class</option>
                            <option>11th</option>
                            <option>12th</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <select className="form-select">
                            <option>Select Medium</option>
                            <option>English</option>
                            <option>Hindi</option>
                        </select>
                    </div>
                </div>
                <button type="submit" className="btn btn-danger formbtn w-100">Apply For IIT GATE</button>
            </form>
        </div>
    );
}
export default CourseForm;